<p-dialog
  [header]="titleKey | abpLocalization"
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: '34rem' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  styleClass="outbound-number-form">
  <form [formGroup]="form" class="d-flex flex-column gap-3" novalidate>
    <div>
      <label for="outbound-phone" class="form-label indicates-required-field">
        {{ 'Settings::PhoneNumbers:PhoneNumber' | abpLocalization }}
      </label>
      <input
        pInputText
        id="outbound-phone"
        type="text"
        inputmode="tel"
        formControlName="phoneNumber"
        [skipValidation]="true"
        [placeholder]="phoneNumberPlaceholder"
        class="form-control" />
      @if (
        form.get('phoneNumber')?.invalid &&
        (form.get('phoneNumber')?.dirty || form.get('phoneNumber')?.touched)
      ) {
        <div class="text-danger small mt-1">
          @if (form.get('phoneNumber')?.errors?.['required']) {
            {{ 'Settings::PhoneNumbers:PhoneNumberRequired' | abpLocalization }}
          } @else if (form.get('phoneNumber')?.errors?.['pattern']) {
            {{ 'Settings::PhoneNumbers:PhoneNumberInvalidFormat' | abpLocalization }}
          }
        </div>
      }
    </div>

    <h6 class="text-uppercase fw-bold small text-body-secondary mt-1 mb-0">
      {{ 'Settings::PhoneNumbers:GatewayConfiguration' | abpLocalization }}
    </h6>

    <div class="row g-3">
      <div class="col-12 col-sm-6">
        <label for="outbound-username" class="form-label">
          {{ 'Settings::PhoneNumbers:Username' | abpLocalization }}
        </label>
        <input
          pInputText
          id="outbound-username"
          type="text"
          formControlName="gatewayUsername"
          [placeholder]="'Settings::PhoneNumbers:UsernamePlaceholder' | abpLocalization"
          class="form-control" />
        <small class="text-body-secondary d-block mt-1">
          {{ 'Settings::PhoneNumbers:UsernameHelp' | abpLocalization }}
        </small>
      </div>

      <div class="col-12 col-sm-6">
        <label for="outbound-password" class="form-label">
          {{ 'Settings::PhoneNumbers:Password' | abpLocalization }}
        </label>
        <p-password
          id="outbound-password"
          formControlName="gatewayPassword"
          [placeholder]="'Settings::PhoneNumbers:PasswordPlaceholder' | abpLocalization"
          [feedback]="false"
          [toggleMask]="true"
          styleClass="w-100 d-block"
          inputStyleClass="form-control w-100"></p-password>
        <small class="text-body-secondary d-block mt-1">
          {{ 'Settings::PhoneNumbers:PasswordHelp' | abpLocalization }}
        </small>
      </div>
    </div>

    <div>
      <label for="outbound-realm" class="form-label">
        {{ 'Settings::PhoneNumbers:Realm' | abpLocalization }}
      </label>
      <input
        pInputText
        id="outbound-realm"
        type="text"
        formControlName="gatewayRealm"
        [placeholder]="'Settings::PhoneNumbers:RealmPlaceholder' | abpLocalization"
        class="form-control" />
      <small class="text-body-secondary d-block mt-1">
        {{ 'Settings::PhoneNumbers:RealmHelp' | abpLocalization }}
      </small>
    </div>

    <div class="row g-3">
      <div class="col-12 col-sm-6">
        <label class="form-label">
          {{ 'Settings::PhoneNumbers:Register' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="gatewayRegister"
          [options]="registerOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body" />
        <small class="text-body-secondary d-block mt-1">
          {{ 'Settings::PhoneNumbers:RegisterHelp' | abpLocalization }}
        </small>
      </div>

      @if (registerEnabled) {
        <div class="col-12 col-sm-6">
          <label class="form-label">
            {{ 'Settings::PhoneNumbers:Protocol' | abpLocalization }}
          </label>
          <cx-select
            class="w-100"
            formControlName="protocol"
            [options]="protocolOptions"
            optionLabel="label"
            optionValue="value"
            appendTo="body" />
          <small class="text-body-secondary d-block mt-1">
            {{ 'Settings::PhoneNumbers:ProtocolHelp' | abpLocalization }}
          </small>
        </div>
      }
    </div>

    <div>
      <label class="form-label indicates-required-field">
        {{ 'Settings::PhoneNumbers:CarrierNumberFormat' | abpLocalization }}
      </label>
      <cx-select
        class="w-100"
        formControlName="carrierNumberFormat"
        [skipValidation]="true"
        [options]="carrierNumberFormatOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body" />
      @if (
        form.get('carrierNumberFormat')?.invalid &&
        (form.get('carrierNumberFormat')?.dirty || form.get('carrierNumberFormat')?.touched)
      ) {
        <div class="text-danger small mt-1">
          {{ 'Settings::PhoneNumbers:CarrierNumberFormatInvalid' | abpLocalization }}
        </div>
      }
      <small class="text-body-secondary d-block mt-1">
        {{ 'Settings::PhoneNumbers:CarrierNumberFormat:Description' | abpLocalization }}
      </small>
    </div>

    <div class="d-flex align-items-center gap-2">
      <p-toggleswitch formControlName="isDefault" inputId="outbound-default"></p-toggleswitch>
      <label for="outbound-default" class="form-label mb-0">
        {{ 'Settings::PhoneNumbers:SetAsDefaultOutbound' | abpLocalization }}
      </label>
    </div>
  </form>

  <ng-template #footer>
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
        {{ 'Settings::PhoneNumbers:Cancel' | abpLocalization }}
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        [disabled]="submitting || form.invalid"
        (click)="submit()">
        {{ submitLabelKey | abpLocalization }}
      </button>
    </div>
  </ng-template>
</p-dialog>
